import { useCallback } from "react";
import {
  Icon,
  SelectTrigger,
  SelectValue,
  type IconName,
} from "@salestrak/ui";
import { isPresetValue, type DatePresetValue } from "#app/lib/utils/date-presets";
import { DateRangePresetPicker } from "#app/components/filters/date-range-preset-picker";
import type { Omittable } from "@salestrak/ui";

type LastUpdatedInputProps = Omittable<{
  value: unknown;
  onChange: (value: unknown) => void;
  icon?: IconName;
}>;

/**
 * Filter input for the "Last updated" quick filter.
 * Stores a DatePresetValue ({ key, custom? }); build-where resolves it to a date range.
 */
export function LastUpdatedInput({ value, onChange, icon }: LastUpdatedInputProps) {
  const presetValue = isPresetValue(value) ? value : null;

  const handleChange = useCallback(
    (next: DatePresetValue) => onChange(next),
    [onChange],
  );

  return (
    <DateRangePresetPicker value={presetValue} onChange={handleChange} align="start">
      {/* SelectValue has no icon slot, so the leading glyph is a sibling of
          the value inside the trigger. */}
      <SelectTrigger size="sm">
        {icon ? <Icon name={icon} size="sm" color="muted" /> : null}
        <SelectValue placeholder="Select last updated..." />
      </SelectTrigger>
    </DateRangePresetPicker>
  );
}
